import CripNotice from "crip-vue-notice";
import { serverAddr, serverAddrToUploadMediaFiles } from "../networkConfig";
import moment from "moment";

export var UploadRecommendationsNetworkCallBack = {
  methods: {
    getAllStockListCallBack(response) {
      if (response.data.status) {
        this.is_stock_list_loading = false;
        this.number_of_pages = response.data.pagination.total_pages;
        this.is_scroll_disabled = true; //enable scroll for more stocks

        response.data.data.forEach((element) => {
          //added result date for each stock object
          // this.$set(element, 'week_result_date', response.data.result_date.week_result_date);
          // this.$set(element, 'month_result_date', response.data.result_date.month_result_date);

          //created new keys to handle next recommendation on reco card
          //e.g. if recommended by week then on click on next btn duration should be change
          // this.$set(element, 'isWeeklyRecommended', false);
          // this.$set(element, 'isMonthlyRecommended', false);
          // this.$set(element, 'isCurrentQuarterRecommended', false);
          // this.$set(element, 'isNextQuarterRecommended', false);

          let price = Number(element.current_price + 2).toFixed(); //increase price by 1

          //calculated potential return initially when target price is initiallised
          let reco_price_potential = this.getPotentailReturn(
            element.current_price,
            element.current_price,
            "Buy"
          );
          let target_price_potential = this.getPotentailReturn(
            price,
            element.current_price,
            "Buy"
          );

          // this.$set(element, 'isTargetPriceDisabled', false);
          this.$set(element, "duration", "");
          this.$set(element, "short_term_duration", "");
          this.$set(element, "long_term_duration", "");
          this.$set(element, "is_unlocked", false);
          this.$set(element, "is_recommended", false);
          this.$set(element, "is_btn_loading", false);
          this.$set(element, "reco_price", Number(element.current_price));
          this.$set(element, "target_price", null);
          this.$set(element, "stop_loss", "");
          this.$set(element, "reco", "Buy");
          this.$set(element, "validate_stop_loss", false);
          this.$set(element, "validate_target_price", false);
          this.$set(element, "validate_reco_price", false);
          this.$set(element, "target_price_error_text", "");
          this.$set(element, "target_price_potential", 0);
          // this.$set(element, "target_price_potential", target_price_potential);
          this.$set(element, "reco_price_potential", reco_price_potential);
          this.$set(element, "stop_loss_potential", "");
          this.$set(element, "risk_tag", "");
          this.$set(element, "selected_logic_list", []);
          this.$set(element, "filtered_logic_list", []);
          this.$set(element, "logic_description", "");
          this.$set(element, "stop_loss_limit", null);
          this.$set(element, "target_price_limit", null);
          this.$set(element, "added_first", "");

          if (this.isMarketClose) {
            this.$set(element, "reco_price_type", "LIMIT");
          } else {
            this.$set(element, "reco_price_type", "MARKET");
          }

          this.stock_list.push(element);

          if (this.stock_list.length > 20) {
            this.is_scroll_disabled = false; //disabled scroll to avoid function call on scroll and to enable get stock by clicking manually
          }
        });
      } else {
        this.is_stock_list_loading = false;
      }
    },

    async uploadRecommendationNetWorkCallBack(response, index) {
      if (response.data.status) {
        this.recos_to_be_upload = [];

        if (
          this.attached_files_list.length ||
          this.logic_description ||
          this.selected_logic_list.length
        ) {
          let uploaded_files_res = await this.uploadRecommendationsLogic(
            response.data.reco.id,
            index
          ); //sent reco id
        }

        this.stock_list[index].validate_target_price = false;
        this.stock_list[index].validate_stop_loss = false;
        this.stock_list[index].validate_reco_price = false;

        this.$set(this.stock_list[index], "is_recommended", true);

        this.$set(this.stock_list[index], "is_summary_out", true);

        this.stock_list[index].is_unlocked = true; //enable unlocked antestimate link
        this.stock_list[index].is_btn_loading = false; //disabled button loader
        this.stock_list[index].antestimate_number = "";
        this.stock_list[index].antestimate_number =
          response.data.reco.antestimate_number;

        // this.sendRecoIdToServer(response.data.reco.id, index);              //sent reco_id to server
        //if duaration e.g. week, month then sent if not then sent Quarter beacause target quarter not getting in duarion key
        this.$set(this.stock_list[index], "reco_id", response.data.reco.id); //assigned reco id to send reco id on antestimate page after clicked on antestimate number

        this.$set(this.stock_list[index], "summary_list", response.data.reco);

        // after uploading recommendation cleared user detial store to show updated reco count on userProfile component
        this.$store.commit("saveUserDetails", {});

        new CripNotice({
          title: "Success",
          description: "Recommendation uploaded",
          type: "success",
          duration: 3,
        });
      } else {
        this.recos_to_be_upload = [];

        this.stock_list[index].is_unlocked = false; //disable unlocked antestimate link
        this.stock_list[index].is_btn_loading = false; //disabled button loader
        this.stock_list[index].antestimate_number = false;

        this.$set(this.stock_list[index], "summary_list", {});

        this.$router.push({
          name: "pastRecommendations",
          query: { reco_id: response.data.data.id },
        });
      }
    },

    //api to send reco_id to server for antestimate calculation : backend logic
    sendRecoIdToServer(reco_id, index) {
      serverAddr
        .post("/recommendation/v1/unlock_ant_number", {
          reco_id: reco_id,
        })
        .then(
          async function(response) {
            if (response.data.status) {
              //api to get reco summary
              // this.getRecommendationSummary(index, reco_id, duration);        //passed index, reco id and duration

              // if (this.attached_files_list.length || this.logic_description) {
              //     let uploaded_files_res = await this.uploadRecommendationsLogic(reco_id , index);
              // }

              new CripNotice({
                title: "Success",
                description: "Recommendation uploaded",
                type: "success",
                duration: 3,
              });

              this.stock_list[index].validate_target_price = false;
              this.stock_list[index].validate_stop_loss = false;
              this.stock_list[index].validate_reco_price = false;

              this.$set(this.stock_list[index], "is_recommended", true);

              this.$set(this.stock_list[index], "is_summary_out", true);

              this.stock_list[index].is_unlocked = true; //enable unlocked antestimate link
              this.stock_list[index].is_btn_loading = false; //disabled button loader
              this.stock_list[index].antestimate_number = "";
              this.stock_list[index].antestimate_number =
                response.data.antsNumber;
              // this.stock_list[index].isTargetPriceDisabled = true;         //disabled target price input field

              //checked conditions to disable previously given recommendation for same duration
              //e.g. if recommended for week then disable it
              // if(this.stock_list[index].duration == "Week"){
              //     this.stock_list[index].isWeeklyRecommended = true;
              // }else if(this.stock_list[index].duration == "Month"){
              //     this.stock_list[index].isMonthlyRecommended = true;
              // }else if(this.stock_list[index].target_quarter == 'next'){
              //     this.stock_list[index].isNextQuarterRecommended = true;
              // }else if(this.stock_list[index].target_quarter == 'current'){
              //     this.stock_list[index].isCurrentQuarterRecommended = true;
              // }
            } else {
              this.stock_list[index].is_unlocked = false; //disable unlocked antestimate link
              this.stock_list[index].is_btn_loading = false; //disabled button loader
              this.stock_list[index].antestimate_number = false;
            }
          }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
        });
    },

    getRecommendationSummary(index, reco_id, duration) {
      serverAddr
        .post("/stockants/read-short-term-reco-summary/", {
          reco_id: reco_id,
          duration: duration,
        })
        .then((response) => {
          if (response.data.status) {
            this.$set(this.stock_list[index], "is_summary_out", true);
            this.$set(
              this.stock_list[index],
              "summary_list",
              response.data.data
            );
          }
        });
    },

    uploadRecommendationsLogic(reco_id) {
      let formData = new FormData();

      if (this.attached_files_list.length) {
        for (var i = 0; i < this.attached_files_list.length; i++) {
          let file = this.attached_files_list[i];
          formData.append(`file${Number(i + 1)}`, file);
        }

        // formData.append("attachments", this.attachment);
      }

      formData.append("description", this.logic_description);
      formData.append("reco_id", reco_id);

      return serverAddrToUploadMediaFiles
        .post("/recommendation/v1/upload-recos-logic", formData)
        .then((response) => {
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getSectorWiseStockListCallBack(response) {
      if (response.data.status) {
        response.data.data.forEach((element, index) => {
          let price = Number(element.current_price + 2).toFixed(); //increase price by 1
          //calculated potential return initially when target price is initiallised

          let reco_price_potential = this.getPotentailReturn(
            element.current_price,
            element.current_price,
            "Buy"
          );
          let target_price_potential = this.getPotentailReturn(
            price,
            element.current_price,
            "Buy"
          );

          // this.$set(element, 'isTargetPriceDisabled', false);
          this.$set(element, "duration", "");
          this.$set(element, "short_term_duration", "");
          this.$set(element, "long_term_duration", "");
          this.$set(element, "is_unlocked", false);
          this.$set(element, "is_recommended", false);
          this.$set(element, "is_btn_loading", false);
          this.$set(element, "reco_price", Number(element.current_price));
          this.$set(element, "target_price", price);
          this.$set(element, "stop_loss", "");
          this.$set(element, "reco", "Buy");
          this.$set(element, "validate_stop_loss", false);
          this.$set(element, "validate_target_price", false);
          this.$set(element, "validate_reco_price", false);
          this.$set(element, "target_price_error_text", "");
          this.$set(element, "target_price_potential", target_price_potential);
          this.$set(element, "reco_price_potential", reco_price_potential);
          this.$set(element, "stop_loss_potential", "");

          //created new keys to handle next recommendation on reco card
          //e.g. if recommended by week then on click on next btn duration should be change
          // this.$set(element, 'isWeeklyRecommended', false);
          // this.$set(element, 'isMonthlyRecommended', false);
          // this.$set(element, 'isCurrentQuarterRecommended', false);
          // this.$set(element, 'isNextQuarterRecommended', false);
          // this.$set(element, 'isTargetPriceDisabled', false);

          //added result date for each stock object
          // this.$set(element, 'week_result_date', response.data.result_date.week_result_date);
          // this.$set(element, 'month_result_date', response.data.result_date.month_result_date);
          // this.$set(element, 'quarter_result_date', response.data.result_date.quarter_result_date);

          //getting current & next quarter result date separately crated separate object and pushed onto quarterList
          // let currentQuarterResultObj = {};
          // currentQuarterResultObj.label = response.data.result_date.current_quarter_result_date;
          // currentQuarterResultObj.value = 'current';

          // let nextQuarterResultObj = {};
          // nextQuarterResultObj.label = response.data.result_date.next_quarter_result_date;
          // nextQuarterResultObj.value = 'next';

          // element.quarterList.push(currentQuarterResultObj);
          // element.quarterList.push(nextQuarterResultObj);

          // //calculated potential return initially when target price is initiallised

          this.sector_wise_stock_list.push(element);
        });
      } else {
        this.sector_wise_stock_list = [];
      }
    },

    getStockByIdCallBack(response) {
      if (response.data.status) {
        this.is_stock_list_loading = false;
        this.number_of_pages = response.data.pagination.total_pages + 1;
        this.is_scroll_disabled = true; //enable scroll for more stocks

        response.data.data.forEach((element, index) => {
          let price = Number(element.current_price + 2).toFixed(); //increase price by 1

          //calculated potential return initially when target price is initiallised
          let reco_price_potential = this.getPotentailReturn(
            element.current_price,
            element.current_price,
            "Buy"
          );
          let target_price_potential = this.getPotentailReturn(
            price,
            element.current_price,
            "Buy"
          );

          // this.$set(element, 'isTargetPriceDisabled', false);
          this.$set(element, "duration", "");
          this.$set(element, "short_term_duration", "");
          this.$set(element, "long_term_duration", "");
          this.$set(element, "is_unlocked", false);
          this.$set(element, "is_recommended", false);
          this.$set(element, "is_btn_loading", false);
          this.$set(element, "reco_price", Number(element.current_price));
          this.$set(element, "target_price", price);
          this.$set(element, "stop_loss", "");
          this.$set(element, "reco", "Buy");
          this.$set(element, "validate_stop_loss", false);
          this.$set(element, "validate_target_price", false);
          this.$set(element, "validate_reco_price", false);
          this.$set(element, "target_price_error_text", "");
          this.$set(element, "target_price_potential", target_price_potential);
          this.$set(element, "reco_price_potential", reco_price_potential);
          this.$set(element, "stop_loss_potential", "");
          // //created new keys to handle next recommendation on reco card
          // //e.g. if recommended by week then on click on next btn duration should be change
          // this.$set(element, 'isWeeklyRecommended', false);
          // this.$set(element, 'isMonthlyRecommended', false);
          // this.$set(element, 'isCurrentQuarterRecommended', false);
          // this.$set(element, 'isNextQuarterRecommended', false);
          // // this.$set(element, 'isTargetPriceDisabled', false);

          // //added result date for each stock object
          // this.$set(element, 'week_result_date', response.data.result_date.week_result_date);
          // this.$set(element, 'month_result_date', response.data.result_date.month_result_date);
          // // this.$set(element, 'quarter_result_date', response.data.result_date.quarter_result_date);

          // //getting current & next quarter result date separately crated separate object and pushed onto quarterList
          // let currentQuarterResultObj = {};
          // currentQuarterResultObj.label = response.data.result_date.current_quarter_result_date;
          // currentQuarterResultObj.value = 'current';

          // let nextQuarterResultObj = {};
          // nextQuarterResultObj.label = response.data.result_date.next_quarter_result_date;
          // nextQuarterResultObj.value = 'next';

          // element.quarterList.push(currentQuarterResultObj);
          // element.quarterList.push(nextQuarterResultObj);

          // //calculated potential return initially when target price is initiallised
          // element.potential_return = this.getPotentailReturn(element.TargetPrice, element.current_price, element.reco);
          this.stock_list.push(element);
        });
      } else {
        this.is_stock_list_loading = false;
      }
    },

    async getRecommendationByRecoIdCallBack(response) {
      if (response.data.status) {
        this.is_stock_list_loading = false;

        if (
          !this.short_term_target_period_list.length &&
          !this.long_term_target_period_list.length
        ) {
          let target_period_res = await this.getTargetPeriod();

          if (
            target_period_res.data.status &&
            target_period_res.data.data.length
          ) {
            let short_term_target_res = target_period_res.data.data.filter(
              (e) => {
                return e.period == "Short-Term";
              }
            );

            short_term_target_res.forEach((element) => {
              let title = "";

              if (
                element.duration == "Quarter" &&
                element.quarters_types == "current"
              ) {
                title = `Current Quarter - ${element.result_date_title}`;
              } else if (
                element.duration == "Quarter" &&
                element.quarters_types == "next"
              ) {
                title = `Next Quarter - ${element.result_date_title}`;
              } else {
                title = `${
                  element.duration == "IntraDay" ? "Intraday" : element.duration
                } - ${element.result_date_title}`;
              }

              let obj = {
                title: title,
                value: element.result_date,
                number: element.number,
                year: element.year,
                duration: element.duration,
              };

              this.short_term_target_period_list.push(obj);
            });

            this.long_term_target_period_list = target_period_res.data.data.filter(
              (e) => {
                return e.period == "Long-Term";
              }
            );
          }
        }

        this.is_scroll_disabled = true; //enable scroll for more stocks

        let reco = response.data.data;

        let price = Number(reco.stock.current_price + 2).toFixed(); //increase price by 1

        //calculated potential return initially when target price is initiallised
        let reco_price_potential = this.getPotentailReturn(
          reco.reco_price,
          reco.stock.current_price,
          reco.reco
        );
        let target_price_potential = this.getPotentailReturn(
          price,
          reco.reco_price,
          reco.reco
        );

        let reco_obj = {
          name: reco.stock.name,
          symbol: reco.stock.symbol,
          sector: reco.stock.sector,
          market_cap: reco.stock.market_cap,
          current_datetime: reco.stock.current_datetime,
          current_price: reco.stock.current_price,
          potential_difference: reco.stock.potential_difference,
          price_difference: reco.stock.price_difference,
          duration: "",
          short_term_duration:
            reco.duration != "Long_term"
              ? moment(reco.result_date_time).format("YYYY-MM-DD HH:mm:ss")
              : "",
          long_term_duration:
            reco.duration == "Long_term"
              ? moment(reco.result_date_time).format("YYYY-MM-DD HH:mm:ss")
              : "",
          is_unlocked: reco.antestimate_number ? true : false,
          antestimate_number: reco.antestimate_number
            ? reco.antestimate_number
            : "",
          is_recommended: false,
          is_btn_loading: false,
          reco_price: Number(reco.reco_price),
          target_price: price,
          stop_loss: reco.stock.stop_loss,
          reco: reco.reco,
          reco_status: reco.reco_status,
          validate_stop_loss: false,
          validate_target_price: false,
          validate_reco_price: false,
          target_price_error_text: "",
          target_price_potential: target_price_potential,
          reco_price_potential: reco_price_potential,
          stop_loss_potential:
            reco.stop_loss_potential && reco.stop_loss_potential != "NA"
              ? reco.stop_loss_potential
              : 0,
        };

        this.stock_list.push(reco_obj);
      } else {
        this.is_stock_list_loading = false;
      }
    },

    //networkcall back of add to fav
    addToFavListCallBack(response, index) {
      if (response.data.status) {
        if (response.data.data.status) {
          this.$set(this.stock_list[index], "add_to_my_fav", "");
          this.$set(this.stock_list[index], "add_to_my_fav", true);

          new CripNotice({
            title: "Success",
            description: "Added to favourite list!",
            type: "success",
            duration: 3,
          });
        } else {
          this.$set(this.stock_list[index], "add_to_my_fav", "");
          this.$set(this.stock_list[index], "add_to_my_fav", false);

          new CripNotice({
            title: "Success",
            description: "Removed from favourite list!",
            type: "success",
            duration: 3,
          });
        }
      }
    },
  },
};
